import React from "react";
import "./BaggageSummary.css";

export default function BaggageSummary({ chips }) {
  if (!chips?.length) return null;
  return (
    <div className="fe2-bags">
      {chips.map((chip) => (
        <span
          key={chip.label}
          className={`fe2-bags__chip fe2-bags__chip--${chip.tone || "muted"}`}
        >
          {chip.label}
        </span>
      ))}
    </div>
  );
}
